import { render, staticRenderFns } from "./QrPaymentRequests.vue?vue&type=template&id=60029f4e&scoped=true"
import script from "./QrPaymentRequests.vue?vue&type=script&lang=js"
export * from "./QrPaymentRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60029f4e",
  null
  
)

export default component.exports